import { createContext, useContext } from 'react'
import type { Section } from '@/lib/sections'

/**
 * The section a shell URL is about (/services → 'about', / → 'home'). Its
 * heading is the page's h1, so each prerendered URL names its own topic;
 * every other section heading is an h2. The visual size follows the
 * section, not the tag (`.h1` / `.h2` in globals.css).
 */
export const PrimarySectionContext = createContext<Section>('home')

/** Tag and class for a section heading that looks like `look`. */
export function useSectionHeading(section: Section, look: 'h1' | 'h2') {
  const primary = useContext(PrimarySectionContext) === section
  const Tag = primary ? 'h1' : 'h2'
  return { Tag, className: Tag === look ? undefined : look } as const
}
